import React, { Component } from 'react'

import { Link } from 'react-router-dom'
import { Icon } from 'loyal-react'
import leftPad from 'left-pad'
import PropTypes from 'prop-types'

import '@loyal_template/autocomplete.css'

import ReactImageFallback from 'react-image-fallback'
import imagefallback from '@loyal_images/products/product_placeholder.png'
class Search extends Component {
  constructor (props) {
    super(props)

    this.state = {
      term: '',
      timer: 0,
      autoCompleteFilled: true,
      verifyTrigger: true,
      clickedSearch: false,
      msgMostSearched: ''
    }
    this.setTerm = this.setTerm.bind(this)
  }

  handleKeyUp (e) {
    clearTimeout(this.state.timer)

    if (e.key === 'Enter') {
      this.emptyTerm()
      this.props.redirect('/search?term=' + e.target.value)
      this.setState({ verifyTrigger: false })
    } else {
      if (process.env.REACT_APP_HAS_AUTOCOMPLETE) {
        this.searchTerm()
      }
    }
  }

  searchTrigger (e) {
    if (e.key !== 'Tab') {
      this.emptyTerm()
      this.props.redirect('/search?term=' + this.state.term)
      this.setState({ verifyTrigger: false })
    }
  }
  emptySearch () {
    this.props.emptySearch()
    this.setAutoComplete(true)
  }
  emptyTerm () {
    this.setState({
      autoCompleteFilled: true,
      term: ''
    })
  }

  setTerm (value) {
    this.setState({ term: value })
  }
  searchTerm () {
    if (process.env.REACT_APP_HAS_AUTOCOMPLETE) {
      if (this.state.term) {
        this.setState({
          timer: setTimeout(() => {
            this.props.fetchSearch(this.state.term)
          }, 1000),
          autoCompleteFilled: true,
          verifyTrigger: true
        })
      } else {
        this.setState({
          autoCompleteFilled: false,
          verifyTrigger: false
        })
      }
    }
  }
  setAutoComplete (isFilled) {
    this.setState({ autoCompleteFilled: isFilled })
  }

  showMostSearchedItems () {
    if (process.env.REACT_APP_HAS_AUTOCOMPLETE) {
      let noSrollBody = document.getElementsByTagName('body')
      noSrollBody[0].classList.add('noSrollBody')

      !this.state.term
        ? this.setState({
          autoCompleteFilled: false
        })
        : this.setState({
          autoCompleteFilled: true
        })
    }
  }

  hideMostSearchedItems () {
    setTimeout(() => {
      if (process.env.REACT_APP_HAS_AUTOCOMPLETE) {
        let noSrollBody = document.getElementsByTagName('body')
        noSrollBody[0].classList.remove('noSrollBody')
      }
      this.emptySearch()
    }, 300)
  }

  render () {
    const searchLabel = 'O que você está buscando?'

    return (
      <div
        className={`search zindex-high d-sm-block d-auto col-xs-12 col-md px-xs-1 px-md-3 px-xl-4 h-100 t-0`}
        role='search'
      >
        <div className='row align-items-center h-100'>
          <div className='col-12 form-field search-field'>
            <p className='hide-absolute color-ui-white' role='status'
              aria-live='assertive'
              aria-atomic='true'>
              {this.state.term !== '' && (this.props.isLoading ? 'Auto-completar: Carregando resultados' : 'Resultado completo')}
            </p>
            <p className='hide-absolute color-ui-white' role='status'
              aria-live='assertive'
              aria-atomic='true'
            >
              {!this.state.autoCompleteFilled ? 'Exibindo os termos mais buscados' : this.state.msgMostSearched}
            </p>
            <div className='box-search-field-desktop d-none d-sm-block'>
              <label htmlFor='buscar-desktop' className='hide-absolute'>{searchLabel}</label>
              <input
                className='no-label no-border radius color-ui-2'
                id='buscar-desktop'
                type='text'
                placeholder={searchLabel}
                name='buscar'
                onChange={e => this.setTerm(e.target.value)}
                value={this.state.term}
                onKeyUp={(e) => this.handleKeyUp(e)}
                onFocus={() => this.searchTerm()}
                onBlur={() =>
                  setTimeout(() => {
                    this.emptySearch()
                  }, 300)
                }
                autoComplete='off'
              />
              <button
                className={`h-100 btn-sm btn btn-flat btn-icon btn-icon-only`}
                aria-label={this.props.isLoading ? `Auto-completar: Carregando resultados...` : `Buscar por produtos`}
                id='btn-search-loupe'
                onClick={e => !this.props.isLoading && this.searchTrigger(e)}
                onBlur={() =>
                  setTimeout(() => {
                    this.emptySearch()
                  }, 300)
                }
                readOnly={this.props.isLoading}
              >
                <Icon
                  iconName={!this.props.isLoading ? 'icon_loupe' : 'icon_loading'}
                  className={!this.props.isLoading ? 'color-brand-2' : 'color-ui-1'}
                />
              </button>
            </div>
            <div id='box-search-field-mobile' className='box-search-field-mobile d-block d-sm-none mx-1'>
              <input
                className='no-label no-border radius color-ui-2'
                id='buscar-mobile'
                type='text'
                tabIndex={0}
                placeholder={searchLabel}
                name='buscar'
                onChange={e => this.setTerm(e.target.value)}
                value={this.state.term}
                onKeyUp={(e) => this.handleKeyUp(e)}
                onFocus={() => this.showMostSearchedItems()}
                onBlur={() => this.hideMostSearchedItems()}
                autoComplete='off'
              />
              <button
                className='h-100 btn-sm btn btn-flat btn-icon btn-icon-only btn-search-loupe-mobile'
                aria-label={this.props.isLoading ? `Auto-completar: Carregando resultados...` : `Buscar por produtos`}
                id='btn-search-loupe-mobile'
                onClick={e => !this.props.isLoading && this.searchTrigger(e)}
                onBlur={() => this.props.emptySearch()}
                readOnly={this.props.isLoading}
              >
                <Icon
                  iconName={!this.props.isLoading ? 'icon_loupe' : 'icon_loading'}
                  className={!this.props.isLoading ? 'color-brand-2' : 'color-ui-1'}
                />
              </button>
            </div>
            <div
              className={`box-autocomplete col-12 px-1 border border-color-ui-4 bg-white radius-bottom ${
                this.props.mostSearched && !this.state.autoCompleteFilled
                  ? ''
                  : 'd-none'
              }`}
            >
              <h2 className='txt-uppercase px-half txt-body-sm py-half mt-1'>
                Termos mais buscados
              </h2>
              <ul className='pb-1'>
                {this.props.mostSearched &&
                  !this.state.autoCompleteFilled &&
                  this.props.mostSearched.map((element, index) => {
                    return (
                      <Link
                        key={index}
                        to={`/search?term=${element.name}`}
                        onClick={() => {
                          this.emptySearch()
                        }}
                      >
                        <li>
                          <div className='row align-items-center h-100 py-1 px-half  bg-ui-4-hv'>
                            <div className='col-auto'>
                              <span
                                className='txt-subtitle txt-font-body bg-brand-1 d-inline-block radius-circle color-ui-white px-half py-half'
                                style={{ width: '22px', textAlign: 'center' }}
                              >
                                {leftPad(index + 1, 2, '')}
                              </span>
                            </div>
                            <div className='col text-body-sm'>
                              <p className='txt-font-body color-ui-3'>{element.name}</p>
                            </div>
                          </div>
                        </li>
                      </Link>
                    )
                  })}
              </ul>
            </div>
            <div
              className={`box-autocomplete col-12 px-1 border border-color-ui-4 bg-white radius-bottom ${
                this.state.term !== '' && this.state.verifyTrigger &&
                (
                  (this.props.categories && this.props.categories.length > 0) ||
                  (this.props.services && this.props.services.length > 0) ||
                  (this.props.products && this.props.products.length > 0)
                )
                  ? '' : 'd-none'
              }`}
            >
              <div
                className={`row ${
                  this.state.verifyTrigger ? 'd-block' : 'd-none'
                }`}
              >
                <div className='col-12'>
                  <ul
                    className={`${
                      this.state.verifyTrigger ? 'd-block' : 'd-none'
                    }`}
                  >
                    {this.props.categories &&
                      this.state.autoCompleteFilled &&
                      this.props.categories.map((element, index) => {
                        return (
                          <Link
                            key={index}
                            to={`/search?term=${this.state.term}&category=${element.id}`}
                            onChange={() => this.setTerm('')}
                          >
                            <li>
                              <div className='row px-1 align-items-center h-100 py-1 bg-ui-4-hv'>
                                <div className='col-auto'>
                                  <Icon
                                    iconName='icon_search'
                                    className='d-inline icon-sm color-ui-3'
                                  />
                                </div>
                                <div className='col-6 mr-auto color-ui-2 txt-body-sm'>
                                  {this.state.term}{' '}
                                  <span className='color-ui-3 txt-body-sm'>
                                    <strong>{element.name}</strong>
                                  </span>
                                </div>
                                <div className='col txt-right'>
                                  <strong className='txt-body-sm'>
                                    {element.count}
                                  </strong>{' '}
                                  <span className='txt-body-sm'>
                                    {element.count === 1
                                      ? 'resultado'
                                      : 'resultados'}
                                  </span>
                                </div>
                              </div>
                            </li>
                          </Link>
                        )
                      })}
                  </ul>
                </div>
                <div className='col-12 px-0 border-top border-color-ui-4 bg-white radius-bottom  '>
                  {this.props.services &&
                    this.state.autoCompleteFilled &&
                    this.props.services.map((element, index) => {
                      return (
                        <div
                          key={index}
                          className='cart-item row mx-0 bg-ui-4-hv px-2 border-bottom border-color-ui-4'
                        >
                          <div className='col-12 '>
                            <Link
                              to={element.path}
                              onClick={() => {
                                this.emptySearch()
                              }}
                              role='link'
                              aria-label='Ver página do produto'
                            >
                              <div className='row align-items-center h-100'>
                                <div className='cart-img px-0 py-2 col-auto txt-center'>
                                  <ReactImageFallback
                                    src={element.image}
                                    fallbackImage={imagefallback}
                                    initialImage={imagefallback}
                                    alt={element.name}
                                    className='card-image-fallback search-img'
                                  />
                                </div>
                                <div className='cart-product-info col'>
                                  <div className='cart-product-info row'>
                                    <div className='product-infos col-12 mx-0'>
                                      <span className='txt-subtitle txt-font-body color-ui-2 '>
                                        {`${element.name.substring(0, 70)} `}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      )
                    })}
                  {this.props.products &&
                    this.state.autoCompleteFilled &&
                    this.props.products.map((element, index) => {
                      return (
                        <div
                          key={index}
                          className='cart-item row mx-0 bg-ui-4-hv px-2 border-bottom border-color-ui-4'
                        >
                          <div className='col-12 '>
                            <Link
                              to={`/products/${element.sku}`}
                              onClick={() => {
                                this.emptySearch()
                              }}
                              role='link'
                              aria-label='Ver página do produto'
                            >
                              <div className='row align-items-center h-100'>
                                <div className='cart-img px-0 py-2 col-auto txt-center'>
                                  <ReactImageFallback
                                    src={element.imageUrl}
                                    fallbackImage={imagefallback}
                                    initialImage={imagefallback}
                                    alt={element.name}
                                    className='card-image-fallback search-img'
                                  />
                                </div>
                                <div className='cart-product-info col'>
                                  <div className='cart-product-info row'>
                                    <div className='product-infos col-12 mx-0'>
                                      <span className='txt-subtitle txt-font-body color-ui-2 '>
                                        {`${element.name.substring(0, 70)} `}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className='col-auto px-1'>
                                  <Link
                                    to='/cart'
                                    className='btn-featured btn-sm btn-icon pl-2 pr-3 radius'
                                    onClick={e => {
                                      const product = {
                                        vendorId: element.vendor && element.vendor.id,
                                        sku: element.sku
                                      }
                                      this.emptySearch()
                                      this.props.addItemCart(product)
                                    }}
                                    role='button'
                                    aria-label='Adicionar produto ao carrinho'
                                  >
                                    <i className='icon icon_cart' />
                                  </Link>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

Search.propTypes = {
  fetchSearch: PropTypes.func,
  emptySearch: PropTypes.func,
  addItemCart: PropTypes.func,
  redirect: PropTypes.func,
  categories: PropTypes.array,
  services: PropTypes.array,
  products: PropTypes.array,
  mostSearched: PropTypes.array,
  isLoading: PropTypes.bool
}

export default Search



// WEBPACK FOOTER //
// ./src/App/Header/Search/Search.js